var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseWave3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 533,
    viewBox: "0 0 1440 533",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 840,
    x2: 840,
    y1: 0.000012,
    y2: 292.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1289.9 70.5371c-212.8-81.8929-384.04-25.5348-561.54-4.4366-177.5 21.0981-298.112-40.7148-463.5-59.26093-165.3882-18.54607-198.377 4.38023-277.4995 24.16083v501.8686h1529.5995l-.96-526.02951s-12.91 145.74051-226.1 63.69761z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseWave3);
export default __webpack_public_path__ + "static/media/course-wave3.94418866a28b767ee8528cd67a139c32.svg";
export { ForwardRef as ReactComponent };